module.exports = __webpack_public_path__ + "static/media/cerdo-fresco.40c12005.jpg";